import React, {useEffect, useState} from 'react'
import styles from '../../styles/dashboard.module.css'
import Header from "../../components/header/header";
import VariableListView from "./views/list_view";
import useMQTTService from "../../components/mqtt_service/mqtt_service";
import axiosInstance from "../../AxiosInstance";
import PageTitle from "../../components/page_title/page_title";
import {useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye} from "@fortawesome/free-solid-svg-icons";
import Modal from "../../components/modal/modal";
import {useTranslation} from "react-i18next";

export default function Variables() {
    const {t} = useTranslation();
    const device = JSON.parse(localStorage.getItem('device'));
    const device_user = JSON.parse(localStorage.getItem('device_user'));
    const [usableData, setUsableData] = useState([]);
    const [locked, setLocked] = useState(false);
    const [hiddenVariables, setHiddenVariables] = useState([]);
    const [showHiddenModal, setShowHiddenModal] = useState(false);
    const [selectedToUnhide, setSelectedToUnhide] = useState([]);

    const navigate = useNavigate();

    // Suscribirse al topic procesado por el backend: myindustrialdata/{device.id}
    const { data } = useMQTTService('myindustrialdata', device?.id);

    useEffect(() => {
        axiosInstance.get(`variable_data/?device_id=${device?.id}`).then((response) => {
            setUsableData(response.data);
        });
        axiosInstance.get(`variable_data/hidden/?device_id=${device?.id}`).then((response) => {
            setHiddenVariables(response.data);
        });
    }, [])

    useEffect(() => {
        if(locked) return;

        if (data && Array.isArray(data) && data.length > 0) {
            // Filter out hidden variables from MQTT updates
            const hiddenIds = new Set(hiddenVariables.map(v => v.id));
            setUsableData(data.filter(v => !hiddenIds.has(v.id)));
        }
    }, [data, locked]);

    const handleHide = (variableId) => {
        const hidden = usableData.find(v => v.id === variableId);
        if (hidden) {
            setHiddenVariables(prev => [...prev, hidden]);
            setUsableData(prev => prev.filter(v => v.id !== variableId));
        }
    };

    const handleUnhide = (variableId) => {
        axiosInstance.post(`variable_data/${variableId}/unhide/`).then(() => {
            const restored = hiddenVariables.find(v => v.id === variableId);
            if (restored) {
                setUsableData(prev => [...prev, restored].sort((a, b) => a.id - b.id));
                setHiddenVariables(prev => prev.filter(v => v.id !== variableId));
            }
        });
    };

    const handleUnhideSelected = () => {
        Promise.all(selectedToUnhide.map(id => axiosInstance.post(`variable_data/${id}/unhide/`))).then(() => {
            const restored = hiddenVariables.filter(v => selectedToUnhide.includes(v.id));
            setUsableData(prev => [...prev, ...restored].sort((a, b) => a.id - b.id));
            setHiddenVariables(prev => prev.filter(v => !selectedToUnhide.includes(v.id)));
            setSelectedToUnhide([]);
        });
    };

    const toggleUnhideSelection = (variableId) => {
        setSelectedToUnhide(prev =>
            prev.includes(variableId) ? prev.filter(id => id !== variableId) : [...prev, variableId]
        );
    };

    const navigationHeader = () => {
        return (
            <div className={'d-flex'}>
                <div style={{cursor: 'pointer'}} onClick={() => navigate('/resources')}>{device_user?.name}</div>
                <div className={'px-1'}>/</div>
                <div style={{cursor: 'pointer'}} onClick={() => navigate('/devices')}>{device?.name}</div>
                <div className={'px-1'}>/</div>
                <div>{t('variables.title')}</div>
            </div>
        );
    }

    return (
        <div className={styles.dashboard_container}>
            <Header/>

            <Modal show={showHiddenModal} setter={(v) => { setShowHiddenModal(v); if (!v) setSelectedToUnhide([]); }} name={t('variables.hidden')} buttonName={null}>
                {hiddenVariables.length === 0 ? (
                    <p style={{color: '#64748B', textAlign: 'center', padding: '16px 0'}}>{t('variables.noHidden')}</p>
                ) : (
                    <>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px'}}>
                            <label style={{display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px', color: '#64748B'}}>
                                <input
                                    type="checkbox"
                                    checked={selectedToUnhide.length === hiddenVariables.length}
                                    ref={el => { if (el) el.indeterminate = selectedToUnhide.length > 0 && selectedToUnhide.length < hiddenVariables.length; }}
                                    onChange={() => {
                                        if (selectedToUnhide.length === hiddenVariables.length) setSelectedToUnhide([]);
                                        else setSelectedToUnhide(hiddenVariables.map(v => v.id));
                                    }}
                                    style={{width: '15px', height: '15px', cursor: 'pointer', accentColor: '#4F46E5'}}
                                />
                                {t('common.selectAll')}
                            </label>
                            {selectedToUnhide.length > 0 && (
                                <button
                                    onClick={handleUnhideSelected}
                                    style={{
                                        padding: '5px 14px', borderRadius: '8px', border: 'none',
                                        backgroundColor: '#4F46E5', color: '#fff',
                                        fontSize: '13px', fontWeight: '600', cursor: 'pointer',
                                    }}
                                >
                                    {t('variables.unhide')} ({selectedToUnhide.length})
                                </button>
                            )}
                        </div>
                        <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                            {hiddenVariables.map(v => (
                                <label key={v.id} style={{
                                    display: 'flex', alignItems: 'center', gap: '12px',
                                    padding: '10px 12px', backgroundColor: selectedToUnhide.includes(v.id) ? '#EEF2FF' : '#F8FAFC',
                                    borderRadius: '8px', border: `1px solid ${selectedToUnhide.includes(v.id) ? '#C7D2FE' : '#E2E8F0'}`,
                                    cursor: 'pointer', transition: 'background 0.15s',
                                }}>
                                    <input
                                        type="checkbox"
                                        checked={selectedToUnhide.includes(v.id)}
                                        onChange={() => toggleUnhideSelection(v.id)}
                                        style={{width: '16px', height: '16px', cursor: 'pointer', accentColor: '#4F46E5', flexShrink: 0}}
                                    />
                                    <span style={{fontWeight: '500', color: '#334155', flex: 1}}>
                                        {v.name || v.variable?.name}
                                    </span>
                                </label>
                            ))}
                        </div>
                    </>
                )}
            </Modal>

            <div className={styles.dashboardInnerContainer}>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap'}}>
                    <PageTitle title={navigationHeader()} back={'/devices'}/>
                    {hiddenVariables.length > 0 && (
                        <button
                            onClick={() => setShowHiddenModal(true)}
                            style={{
                                display: 'flex', alignItems: 'center', gap: '6px',
                                padding: '6px 14px', borderRadius: '8px',
                                border: '1px solid #CBD5E1', background: '#F1F5F9',
                                cursor: 'pointer', color: '#475569', fontSize: '13px', fontWeight: '500',
                                marginRight: '8px', marginBottom: '8px'
                            }}
                        >
                            <FontAwesomeIcon icon={faEye} color={'#475569'}/>
                            {t('variables.hidden')} ({hiddenVariables.length})
                        </button>
                    )}
                </div>

                <VariableListView data={usableData} setLocked={setLocked} onHide={handleHide}/>
            </div>
        </div>
    )
}
